import { render, staticRenderFns } from "./SharerMap.vue?vue&type=template&id=2b5c81a6"
import script from "./SharerMap.vue?vue&type=script&lang=js"
export * from "./SharerMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports